import React from 'react';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';

const LogModal = ({ logs, onClose, onSave }) => {
  const formatLogs = (logs) => {
    const formattedLogs = [];
    for (const date in logs) {
      formattedLogs.push(`Data: ${format(new Date(date), 'dd MMMM yyyy', { locale: it })}`);
      logs[date].forEach((slot, index) => {
        formattedLogs.push(`  Time Slot ${index + 1}: ${slot.startTime} - ${slot.endTime}`);
      });
    }
    return formattedLogs.join('\n');
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-2xl font-bold mb-4">Logs</h2>
        <pre className="bg-gray-100 p-4 rounded-lg overflow-auto max-h-96">{formatLogs(logs)}</pre>
        <div className="flex justify-end mt-4">
          <button onClick={onSave} className="bg-[#3e96ac] text-white px-4 py-2 rounded-lg shadow-md hover:bg-[#e06615] mr-2">Salva Modifiche</button>
          <button onClick={onClose} className="bg-gray-600 text-white px-4 py-2 rounded-lg shadow-md hover:bg-gray-800">Chiudi</button>
        </div>
      </div>
    </div>
  );
};

export default LogModal;